import React, { Component } from "react";
import SrNoValidation from "./SRNoValidation";
import axios from "axios";
import { GET_ASSESSMENT, REGISTER_STUDENT, SRNO_VALIDATE } from "../../constants/apiContants";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
// import { Popover, Typography } from "@material-ui/core";
// import { Alert, AlertTitle } from '@material-ui/lab';



class SRNoValidationComponent extends Component {
    constructor(props) {
        super(props);
        // this.validate = this.validate.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleError = this.handleError.bind(this);
        this.registerSRNumber = this.registerSRNumber.bind(this);

    }


    state = {
        textInput: "",
        flag: false,
        data: [],
        showError: false,
        assessmentClasses: [],
        confirm: false,
        message: '',
        statusCode: 0,
        showServerError: false,
        noAssessmentId: false,
        showBusyIndicator: false
    };
    componentDidMount() {
        console.log(this.props.history);
        axios.get(GET_ASSESSMENT).then(res => {
            console.log("Assessment Classes", res)
            this.setState({ assessmentClasses: res.data })
        }).catch(err => {
            console.log("Error", err)
        })
        const urlParams = new URLSearchParams(window.location.search);
        const assessId = urlParams.get('assessmentId');
        console.log("assessID", assessId)
        if (assessId == "" || assessId == null) {
            this.setState({ noAssessmentId: true })
        }
    }

    handleValidation(res) {
        // const history = useHistory()
        console.log("result", res);
        this.setState({ flag: true });
        if (res.data.success) {
            this.props.history.push({
                pathname: "/instructions",
                // search: "?query=abc",
                state: {
                    data: res.data, assessmentDetails: res.data.assessmentDetails,
                    studentDetails: res.data.studentDetails, doNotSaveFlag: false
                },
            });
        }
        else {
            this.setState({ showError: true })
            setInterval(() => {
                this.setState({ showError: false })
            }, 4000);
        }

    }

    handleError(err) {
        console.log("error", err);
    }

    registerSRNumber(studentName, classId, parentName, srNumberPost, mobileNumber, diseCode) {
        console.log("Data", studentName, classId, parentName, srNumberPost, mobileNumber, diseCode)
        const data = {
            SRNumber: srNumberPost,
            createdBy: "5e29398eb9d1be2da6d64291",
            department: "5f4e1049880bbb282dd641a4",
            diseCode: "09100203002",
            name: "Nuralika",
            parentMobile: "9948729733",
            parentName: "Naga P5"
        }
        axios.post(REGISTER_STUDENT,)
    }

    validate = (e) => {
        const urlParams = new URLSearchParams(window.location.search);
        const assessId = urlParams.get('assessmentId');
        if (assessId == "") {
            this.setState({ noAssessmentId: true })
        }
        console.log("assessmentId", assessId);
        // this.props.validate(this.state.textInput, this.handlevalidation, this.handleError)
        //let assessmentId = "clzGxWRk3woZ92wYAUtuaILicNfEzJMzCJ0Js%2BsgL3A%3D"
        let assessmentId = assessId; 
        let url = SRNO_VALIDATE + "?srnNo=" + this.state.textInput + "&assessmentId=" + assessmentId
        console.log("validateSRNumber", this.state);
        this.state.showBusyIndicator = true;
        e.preventDefault();
        axios.post(url, "")
            .then(response => {
                console.log(response)
                this.setState({ data: response, message: response.data.message, statusCode: response.data.statusCode })
                if (response.data.success) {
                    this.handleValidation(response)
                }
                else {
                    this.setState({ confirm: true })
                }
                this.setState({ showBusyIndicator: false })
            }).catch(error => {
                this.setState({ confirm: true });
                this.setState({ showBusyIndicator: false })
                console.log(error);
            })
        // const history = useHistory()
        // this.props.history.push({ pathname: "/instructions", search: '?query=abc', state: {data: "OK"}})
    };

    handleNavigationWithoutSRNumber() {
        console.log("handleNavigation", this.state.data)
        var res = this.state.data
        this.props.history.push({
            pathname: "/instructions",
            // search: "?query=abc",
            state: {
                data: res.data, assessmentDetails: res.data.assessmentDetails,
                doNotSaveFlag: true
                // studentDetails: res.data.studentDetails
            },
        });
    }

    renderAlert() {
        const { statusCode, message } = this.state
        if (statusCode == 600 || statusCode == 601 || statusCode == 602) {
            return (
                <Dialog
                    open={this.state.confirm}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.handleNavigationWithoutSRNumber() }} color="primary">
                            Proceed
                                </Button>
                        <Button onClick={() => { this.setState({ confirm: false }) }} color="primary" autoFocus>
                            Cancel
                            </Button>
                    </DialogActions>
                </Dialog>
            )
        }
        else if (statusCode == 603) {
            return (
                <Dialog
                    open={this.state.confirm}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            This assessment is not be available
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.setState({ confirm: false }) }} color="primary" autoFocus>
                            Ok
                            </Button>
                    </DialogActions>
                </Dialog>
            )
        }

    }

    render() {
        // const { class}

        var studentName = ''
        console.log("studentName", this.state.message)
        return (
            <div>
                <SrNoValidation validateSRNumber={this.validate}
                    setTextInputValue={
                        (res) => this.setState({ textInput: res })}
                    flag={this.state.flag}
                    error={this.state.showError}
                    data={this.state.assessmentClasses}
                    open={this.state.showBusyIndicator}
                // registerSRNumber={this.registerSRNumber}
                // studentName={studentName}
                />
                {this.renderAlert()}
                <Dialog
                    open={this.state.noAssessmentId}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            This is invalid url please use shared url
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.setState({ noAssessmentId: false }) }} color="primary">
                            Ok
                            </Button>
                    </DialogActions>
                </Dialog>
                {/* <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                        This is an error alert — <strong>check it out!</strong>
                </Alert> */}

            </div>
        );
    }
}

export default SRNoValidationComponent;